module.exports = __webpack_public_path__ + "static/img/reference pics_house1.64ad61d8.jpg";